import { startVoice } from 'public/speechlyVoiceSearch.js'

$w.onReady(function () {
    startVoice();
});

export function statebox9_mouseIn(event) {
    $w('#statebox9').show();
}

export function statebox9_mouseOut(event) {
    $w('#statebox9').hide();
}

export function button138_mouseIn(event) {
    $w('#statebox9').changeState("Brands");
    $w('#statebox9').show();
}

export function button138_mouseOut_1(event) {
    $w('#statebox9').hide();
}

export function button136_mouseIn(event) {
    $w('#statebox9').changeState("state3");
    $w('#statebox9').show();
}

export function button136_mouseOut(event) {
    $w('#statebox9').hide();
}

export function button135_mouseIn(event) {
    $w('#statebox9').changeState("Bottoms");
    $w('#statebox9').show();
}

export function button135_mouseOut(event) {
    $w('#statebox9').hide();
}

export function button134_mouseIn(event) {
    $w('#statebox9').changeState("state2");
    $w('#statebox9').show();
}

export function button134_mouseOut(event) {
    $w('#statebox9').hide();
}

export function button132_mouseIn(event) {
    $w('#statebox9').changeState("state1");
    $w('#statebox9').show();
}

export function button132_mouseOut(event) {
    $w('#statebox9').hide();
}

export function statebox9_mouseIn_1(event) {
    $w('#statebox9').show();
}

export function statebox9_mouseOut_1(event) {
    $w('#statebox9').hide();
}